import { Button } from 'rsuite';
import { Layout } from '../../../../../components';
import { AsyncCheckPill } from '../../../../../components/Filters';
import styles from './OfertasFilters.module.scss';
import { useOfertasFilters } from './useOfertasFilters';

export const OfertasFilters = () => {
  const { list: filters } = useOfertasFilters();

  return (
    <Layout.Section padded>
      <section className={styles.wrapper}>
        <div className={styles.content}>
          <div>
            {filters.map(filter => {
              return !filter.dataKey.match(/categoryLevel/) && <AsyncCheckPill {...filter} key={filter.dataKey} />;
            })}
          </div>

          <div>
            {filters.map(filter => {
              return filter.dataKey.match(/categoryLevel/) && <AsyncCheckPill {...filter} key={filter.dataKey} />;
            })}
          </div>
        </div>
        <Button
          className="filter-button"
          onClick={() => {
            filters.forEach(filter => {
              filter.onClean?.();
            });
          }}
        >
          Limpar filtros
        </Button>
      </section>
    </Layout.Section>
  );
};
